module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "recomendationsContainer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    on: {
      "click": _vm.scrollToRecomendations
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.t('Our recomendations')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "recomendationList row m-t-3"
  }, _vm._l((_vm.recomendations), function(recomendation) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4 col-lg-4 col-xl-4 recomendation m-b-2"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + _vm.language + '/activity/' + recomendation.slug
      }
    }, [_c('ActivityCard', {
      staticClass: "sameHeight",
      attrs: {
        "activity": recomendation,
        "headerIcons": false
      }
    })], 1)], 1)
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47341001", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47341001"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Recomendations.vue
// module id = 773
// module chunks = 3